export const emptyStringValuesToNull = (
  object: Record<string, unknown> | null | undefined
): Record<string, unknown> | null | undefined => {
  if (!object) {
    return object;
  }

  // if the value in one of the keys is an empty string, null or undefined, set it to null
  const newObject: Record<string, unknown> = {};
  Object.keys(object).forEach((key) => {
    if (
      object[key] === "" ||
      object[key] === null ||
      object[key] === undefined
    ) {
      newObject[key] = null;
    } else {
      newObject[key] = object[key];
    }
  });
  return newObject;
};
